import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/price-up.svg";
var PriceUpOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  PriceUpOutline_default as default
};
